import React, { Component } from 'react';

import Input from '~/common/components/Input';
import Tooltip from '~/common/components/Tooltip';
import InfoIcon from '~/common/components/InfoIcon2';
import { isTouchDevice } from '~/common/utils/deviceDetection.js';

import styles from './inputField.css';

const IS_TOUCH_DEVICE = isTouchDevice();

export default class InputField extends Component {
    state = {
        isFocus: false
    };

    setFocusState(e) {
        this.setState({ isFocus: true });
        if (this.props.onFocus) this.props.onFocus(e);
    }

    setBlurState(e) {
        this.setState({ isFocus: false });
        if (this.props.onBlur) this.props.onBlur(e);
    }

    createMarkup = (markup) => {
        return { __html: markup };
    };


    render() {
        const { id, label, error, hint, defaultValue, wrapperClass, warning, displayHintOnError, toolTip, tooltipPositionTouch } = this.props;
        // when displayHintOnError will display the hint when the field is focused and or has an error, otherwise only when the field is focused
        const displayHint = displayHintOnError ? hint && (this.state.isFocus || error) : hint && this.state.isFocus;

        return (
            <div
                className={`${styles.wrapper} ${wrapperClass || ''}`}
            >
                <Input
                    {...this.props}
                    onBlur={e => this.setBlurState(e)}
                    onFocus={e => this.setFocusState(e)}
                />
                <label className={`${styles.label} ${defaultValue ? styles.min : ''} ${error ? styles.error : ''} ${warning ? styles.warning : ''}`} htmlFor={id}>{label}</label>
                {error && <div className={styles['error-message']} dangerouslySetInnerHTML={this.createMarkup(error)} />}
                {warning && <div className={styles['warning-message']}>{warning}</div>}
                {displayHint && <div className={styles.hint}>{hint}</div>}
                {toolTip &&
                    <Tooltip
                        activeTriggerModifiers={styles['tooltip-trigger--active']}
                        content={
                            <div>
                                <p>
                                    <span>{toolTip}</span>
                                </p>
                            </div>
                        }
                        contentModifiers={styles.content}
                        fromDirection={IS_TOUCH_DEVICE ? 'right' : 'left'}
                        tooltipPositionTouch={tooltipPositionTouch}
                        triggerModifiers={styles['tooltip-trigger']}
                    >
                        <InfoIcon
                            modifier={`${
                                styles['info-icon']} ${
                                styles['info-icon--margin-right']} ${
                                IS_TOUCH_DEVICE ? styles['info-icon--touch-device'] : ''
                            }`}
                        />
                    </Tooltip>
                }
            </div>
        );
    }
}
